// بيانات الشات بوت - الأسئلة الشائعة والإجابات
const chatbotData = {
  // رسالة الترحيب
  initialMessage: "جاري الانضمام للمحادثة...",
  welcomeMessage: "السلام عليكم، اتفضل كيف أقدر أخدمك؟",
  idleMessage: "هل تريد الاستفسار عن الدورات أم الكتب؟",
  
  // ردود على التحيات
  greetings: {
    "مرحبا": "مرحبا بك! اتفضل ازاي أقدر أخدمك؟",
    "السلام عليكم": "وعليكم السلام ورحمة الله وبركاته. كيف يمكنني مساعدتك؟",
    "هلا": "هلا وغلا! اتفضل شلون أقدر أساعدك؟"
  },
  
  // رد على شيء آخر
  otherInquiry: {
    "شيء آخر": "أخبرني ما هي المشكلة التي تواجهها بالضبط؟ يمكنك التواصل مع:\n\n• الدعم الفني على رقم الواتساب: <a href='https://api.whatsapp.com/send/?phone=966505192363' target='_blank'>0505192363</a>\n\n• المبيعات والاستفسارات العامة: <a href='https://api.whatsapp.com/send/?phone=966505192363' target='_blank'>0505192363</a>"
  },
  
  // الأسئلة المقترحة للدورات
  coursesSuggestions: [
    "كيف أشترك بالدورة؟",
    "طرق الدفع المتاحة",
    "واجهت مشكلة فنية",
    "كيف أكلم المدرب؟"
  ],
  
  // الأسئلة المقترحة للكتب
  booksSuggestions: [
    "كيف أشتري كتاب؟",
    "كيف أحصل على كتاب إلكتروني؟",
    "ما هي سياسة الإرجاع؟",
    "بلغ عن مشكلة بكتاب"
  ],
  
  // الأسئلة والإجابات الشائعة
  faqs: [
    {
      id: 1,
      category: "التسجيل والاشتراك",
      keywords: ["تسجيل", "اشتراك", "حساب", "سجل", "أشترك", "انضمام", "أسجل", "حجز", "مقعد"],
      questions: [
        "كيف أشترك بالدورة؟",
        "طريقة التسجيل؟",
        "أبي أسجل في الموقع",
        "كيف أحجز مقعد بالدورة؟",
        "خطوات الاشتراك"
      ],
      answer: "للتسجيل في الدورات، اتبع الخطوات التالية:\n1. انشئ حساب جديد من صفحة 'تسجيل' إذا لم يكن لديك حساب\n2. قم بتسجيل الدخول لحسابك\n3. تصفح الدورات المتاحة واختر الدورة المناسبة\n4. اضغط على زر 'اشتراك' أو 'شراء الدورة'\n5. أكمل عملية الدفع\n6. مبروك! يمكنك الآن الوصول إلى محتوى الدورة"
    },
    {
      id: 2,
      category: "طرق الدفع",
      keywords: ["دفع", "سداد", "فيزا", "ماستركارد", "بطاقة", "مدفوعات", "تكلفة", "سعر", "اشتري", "تقسيط"],
      questions: [
        "طرق الدفع المتاحة",
        "كيف أسدد قيمة الدورة؟",
        "أبي أدفع عن طريق الفيزا",
        "هل يوجد دفع إلكتروني؟",
        "تقسيط الدورات"
      ],
      answer: "نوفر لك العديد من طرق الدفع المريحة:\n1. البطاقات الائتمانية (فيزا، ماستركارد)\n2. مدى (للبطاقات المحلية)\n3. Apple Pay\n4. التحويل البنكي\n5. STC Pay\n\nعند إتمام عملية الشراء ستظهر لك جميع خيارات الدفع المتاحة."
    },
    {
      id: 3,
      category: "الدعم الفني",
      keywords: ["مشكلة", "خطأ", "عطل", "فني", "تقني", "صعوبة", "دعم", "مساعدة", "تسجيل دخول", "كلمة مرور"],
      questions: [
        "واجهت مشكلة فنية",
        "الفيديو ما يشتغل معي",
        "الموقع بطيء",
        "نسيت كلمة المرور",
        "كيف أحل مشكلة تسجيل الدخول؟"
      ],
      answer: "نأسف لوجود مشكلة تقنية. يمكنك اتباع هذه الخطوات:\n\n1. تحديث الصفحة (F5)\n2. مسح ذاكرة التخزين المؤقت للمتصفح\n3. استخدام متصفح آخر (نوصي بـ Chrome أو Firefox)\n4. التأكد من سرعة الإنترنت\n\nإذا استمرت المشكلة، تواصل معنا عبر الواتساب: <a href='https://api.whatsapp.com/send/?phone=966505192363' target='_blank'>0505192363</a>"
    },
    {
      id: 4,
      category: "التواصل مع المدربين",
      keywords: ["مدرب", "معلم", "استاذ", "محاضر", "سؤال", "استفسار", "تواصل", "اسأل", "رد"],
      questions: [
        "كيف أكلم المدرب؟",
        "التواصل مع المحاضر",
        "أبي أسأل المدرب سؤال",
        "هل يوجد منتدى للأسئلة؟",
        "المدرب ما رد على استفساري"
      ],
      answer: "يمكنك التواصل مع المدرب بعدة طرق:\n\n1. استخدم ميزة 'اسأل المدرب' الموجودة في صفحة الدورة\n\n2. اكتب سؤالك في صفحة اسأل من الشريط العلوي بجانب تسجيل الخروج\n\nيسعى المدربون للرد في أسرع وقت، عادة خلال 24-48 ساعة."
    },
    {
      id: 5,
      category: "الشهادات",
      keywords: ["شهادة", "إتمام", "اعتماد", "معتمدة", "وثيقة", "إنجاز", "مؤهل", "دبلوم"],
      questions: [
        "هل أحصل على شهادة؟",
        "شهادة إتمام الدورة",
        "الشهادة معتمدة؟",
        "كيف أطلب نسخة من الشهادة؟",
        "متى أستلم الشهادة؟"
      ],
      answer: "نعم، تحصل على شهادة إتمام عند إكمال جميع متطلبات الدورة.\n\nالشهادات معتمدة من منصتنا ويمكن مشاركتها على LinkedIn. بعض الدورات لها شهادات خاصة معتمدة من جهات خارجية.\n\nيتم إصدار الشهادة تلقائياً فور إتمام جميع أجزاء الدورة والاختبارات."
    },
    {
      id: 6,
      category: "الاختبارات التدريبية",
      keywords: ["اختبار", "تدريب", "حل", "امتحان", "درجة", "تقييم", "فيديو", "شرح", "تدريبي"],
      questions: [
        "كيف أصل لاختبارات التدريب؟",
        "أين أجد شرح حلول الاختبارات؟",
        "هل يوجد فيديوهات تشرح الحلول؟",
        "كم عدد الاختبارات التدريبية بالدورة؟",
        "كيف أعرف درجتي في الاختبار التدريبي؟"
      ],
      answer: "تجد الاختبارات التدريبية في نهاية كل قسم من أقسام الدورة. بعد كل اختبار تدريبي، ستجد فيديو شرح كامل للحلول.\n\nيمكنك إعادة الاختبارات التدريبية عدة مرات لتحسين مستواك. نتائجك تُحفظ تلقائياً في حسابك لمتابعة تقدمك."
    },
    {
      id: 7,
      category: "المواد التعليمية",
      keywords: ["ملف", "مرفق", "تحميل", "مادة", "محتوى", "كتاب", "مذكرة", "PDF", "عرض", "طباعة"],
      questions: [
        "أين أجد ملفات الدورة؟",
        "كيف أحمل المرفقات؟",
        "مدة صلاحية الوصول للمحتوى",
        "هل يمكن طباعة المواد التعليمية؟",
        "أبي نسخة من العرض التقديمي"
      ],
      answer: "تجد ملفات ومرفقات الدورة أسفل كل درس. يمكنك تحميل معظم المواد بصيغة PDF بالضغط على أيقونة التحميل.\n\nلديك وصول مدى الحياة للمحتوى بعد شراء الدورة. يمكنك طباعة المواد لاستخدامك الشخصي، مع مراعاة حقوق الملكية الفكرية."
    },
  ],

  // الردود على الاستفسارات المتعلقة بالكتب
  books: {
    "كيف أشتري كتاب؟": "يمكنك شراء الكتاب من خلال صفحة المتجر على موقعنا. اختر الكتاب الذي ترغب به، وأضفه إلى سلة التسوق، ثم قم بتعبئة بيانات الشحن والدفع.",
    "كيف أحصل على كتاب إلكتروني؟": "بعد شراء الكتاب الإلكتروني، ستتلقى رابط التحميل على بريدك الإلكتروني المسجل. كما يمكنك الوصول إلى مكتبتك الرقمية من خلال حسابك على موقعنا.",
    "ما هي سياسة الإرجاع؟": "يمكنك إرجاع الكتاب خلال 14 يومًا من تاريخ الاستلام، شرط أن يكون بحالة جيدة وبدون أي أضرار. الكتب الإلكترونية غير قابلة للإرجاع بعد الشراء.",
    "بلغ عن مشكلة بكتاب": "نأسف للمشكلة التي تواجهها. يمكنك التواصل مع فريق خدمة العملاء عبر واتساب على الرقم <a href='https://api.whatsapp.com/send/?phone=966505192363' target='_blank'>0505192363</a> مع ذكر رقم طلبك ووصف المشكلة بالتفصيل."
  },
  
  // الرسالة الافتراضية إذا لم يتم العثور على إجابة
  defaultMessage: "عذراً، لم أفهم سؤالك. يمكنك طرح أسئلة محددة أو التواصل مع فريق الدعم عبر واتساب على الرقم: 0505192363"
};

export default chatbotData;
